export const TemplateType = {
  TOP_BANNER: 'TOP_BANNER',
  CENTER_MODAL: 'CENTER_MODAL',
  FULL_SCREEN: 'FULL_SCREEN',
};

export const Step = {
  TEMPLATE: 'template',
  CONTENT: 'content',
  STYLE: 'style',
  AUDIENCE: 'audience',
};

